<script>
import Box from '@/components/atoms/Box.vue'

export default {
    name: 'CheckoutErrorBlock',

    components: { Box },

    props: {
        orderErrors: {
            type: Array,
            default: () => [],
        },
        possibleErrors: {
            type: Array,
            default: () => [],
        },
        calculationErrors: {
            type: Array,
            default: () => [],
        },
        stripe: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            innerPossibleErrors: [],
            scrollableCalculationErros: [
                'requiredDeliveryTime',
                'groupOrderSumDistribution',
                'expense_code',
            ],
            correspondingIds: {
                groupOrderSumDistribution: 'group_info',
            },
        }
    },

    computed: {
        showErrors() {
            return (
                !!this.orderErrors?.length ||
                !!this.innerPossibleErrors?.length ||
                !!this.calculationErrors?.length ||
                this.creditCardError
            )
        },
        creditCardError() {
            return (
                this.$cart?.payment_method === 'stripe' &&
                this.$cart?.calculation?.price_sum < this.stripe.minimumAmount
            )
        },
    },

    watch: {
        possibleErrors: {
            immediate: true,
            deep: true,
            handler(possibleErrors) {
                this.$nextTick(() => {
                    this.innerPossibleErrors = possibleErrors.reduce((p, c) => {
                        if (typeof c === 'string' || (c.id && (c.key || c.error))) {
                            p.push({
                                button: !!document.querySelector(`#${c?.id || c}`),
                                id: c.id ? c.id : c,
                                key: c.id ? c.key : c,
                                error: c?.error,
                            })
                        }
                        return p
                    }, [])
                })
            },
        },
    },

    methods: {
        highlightBlock(id) {
            const element = document.querySelector(`#${this.correspondingIds[id] || id}`)
            if (element) {
                element.classList.add('highlight')
                setTimeout(() => {
                    element.classList.remove('highlight')
                }, 2000)
            }
        },
        scrollTo(propertyPath) {
            return this.scrollableCalculationErros.includes(propertyPath)
                ? `#${this.correspondingIds[propertyPath] || propertyPath}`
                : undefined
        },
    },
}
</script>

<template lang="pug">
box.no-bg(:value="showErrors" slim transparent)
    .alert.alert-info(v-for="(error, index) in orderErrors" :key="`orderError-${index}`")
        icon.mr-2(icon="fa-solid fa-exclamation-circle")
        span {{error.message}}
    .alert.alert-info.d-flex.align-items-center(
        v-for="(error, index) in innerPossibleErrors"
        v-scroll-to="error.button ? `#${error.id}` : undefined"
        @click="highlightBlock(error.id)"
        :key="`possibleError-${index}`"
        :role="error.button ? 'button' : undefined")
        icon.mr-2(icon="fa-solid fa-exclamation-circle")
        span {{ error.error || $t(`order.checkout_errors.${error.key}`) }}
        icon.ml-auto(v-if="error.button" icon="fa-solid fa-share")
    .alert.alert-info.d-flex.align-items-center(
        v-for="(error, index) in calculationErrors" 
        v-scroll-to="scrollTo(error.propertyPath)"
        @click="highlightBlock(error.propertyPath)"
        :key="`calculationError-${index}`"
        :role="scrollableCalculationErros.includes(error.propertyPath) ? 'button' : undefined")
        icon.mr-2(icon="fa-solid fa-exclamation-circle")
        span {{error.message}}
        icon.ml-auto(v-if="scrollableCalculationErros.includes(error.propertyPath)" icon="fa-solid fa-share")
    .alert.alert-info.d-flex.align-items-center(v-if="creditCardError")
        icon.mr-2(icon="fa-solid fa-exclamation-circle")
        span {{ $t('order.stripe_minimum', {minimum: $options.filters.toCurrency(stripe.minimumAmount) }) }}
</template>
